<i18n>
{
  "en": {
    "systems": "Systems",
    "serialnumber": "Serial number",
    "footer": "Select Ellipse system serial number from drop down list",
    "buttons": {
      "credit": "Time/Pulse File",
      "configuration": "Configuration File"
    }
  },
  "da": {
    "systems": "Systemer",
    "serialnumber": "Serienummer",
    "footer": "Vælg Ellipse system serienummer fra dropdown liste",
    "buttons": {
      "credit": "Tids-/Pulsfil",
      "configuration": "Konfigurationsfil"
    }
  }
}
</i18n>

<template>
<div>

  <layout>

    <b-container>
    
      <b-row>
          <b-col lg="8" offset-lg="2"> 
          <b-row>
            <div id="system-header">
              <h1 class="">{{ $t('systems') }}</h1>
            </div>
          </b-row>

          <b-row>
            <div id="system-footer">
              <h6>{{$t('footer')}}</h6>
            </div>
          </b-row>

          <b-form>
            {{$t('serialnumber')}}
            <v-select id="" v-model="selected" :options="systems" class="pb-3 style-chooser" style="content: none"></v-select> 

          </b-form>

          <b-row><!-- System Buttoms -->
            <b-col class="md-6">
              <b-row align-h="start">
                <b-button type="button" variant="outline-secondary" v-on:click="selectSystem" :disabled="continueEnabled" v-if="this.role === 'EllipseAdmin' || this.role === 'CreditDistributor'">{{$t('buttons.credit')}}</b-button>
              </b-row>
            </b-col>

            <b-col class="md-6">
              <b-row align-h="end">
                <b-button type="button" variant="outline-secondary" v-on:click="systemConfiguration" :disabled="continueEnabled" v-if="this.role === 'EllipseAdmin' || this.role === 'EllipseTech'">{{$t('buttons.configuration')}}</b-button>
              </b-row>
            </b-col>


          </b-row>
        </b-col>

      </b-row>
    </b-container>
  </layout>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import vSelect from 'vue-select'

import _ from "lodash";
import axios from 'axios'

import elg from '../api/elg.gateway.js'
import jwt from '../utils/jwt.js'

import Layout from './Layout'

export default {
  ...mapActions(['logout']), 
  components: {
    Layout,
    vSelect
  },
  data() {
    return {
      systems: [],
      selected: undefined
    };
  },

  computed: {
    continueEnabled(){
      return (this.selected === undefined || this.selected === null);
    },
    role() {
      return jwt.getRole()
    },
  },

  methods: {
    ...mapActions(['logout']),
    contains(obj){
      var found = false;
      for(var i = 0; i < this.systems.length; i++){
        if( this.systems[i].LogosID === obj.LogosID ){
          found = true;
          break;
        }
      }

      return found;
    },
    logoutUser() {
      this.logout();
      window.location.href = '/'; // Hard-reset of page
    },
    selectSystem(){
      if(this.selected === undefined)
        return; 

      this.$router.push({
        name: 'system-credits-overview',
        params:{
          logosid: this.selected.value
        }
      })
    },


    systemConfiguration(){
      if(this.selected === undefined)
        return; 

      this.$router.push({
        name: 'system-config-overview',
        params:{
          logosid: this.selected.value
        }
      })
    }
  },

  mounted() {    
    elg()
    .get("/api/v1/systems")
    .then(res => {
      var data = res.data;

      for (var i = 0; i < data.length; i++) {
        var terminal = data[i];
        if(!this.contains(terminal) && terminal.SerialNumber !== ''){
          this.systems.push({
            value: terminal.LogosID,
            label: terminal.SerialNumber
          });
        }
      }
    });
  }
};
</script>

<style scoped>

#site-navbar{
  background-color: #3388CC !important;
}

.highlight{
  background-color: #A6228C
}

#system-header{
  margin-top: 18px;
  background-color: lightgrey;
  border-radius: 5px 5px 5px 5px;
  height: 75px;
  margin-bottom: 20px;
  width:100%;
}

#system-header > h1{
  padding-top: 10px;
  padding-left: 15px;

  color: #8C8C8C;
  font-weight: bold;
}

#system-footer{
  height: 40px;
  margin: 0;
  background-color: darkgrey;
  margin-bottom: 20px;
  width:100%;
}

#system-footer > h6 {
  color: black;
  font-weight: normal;
  padding-left:15px;
  padding-top:10px;
}


</style>


// WEBPACK FOOTER //
// WebApp/components/Systems.vue